import {
  CreditCard,
  Database,
  LayoutDashboard,
  MessageSquare,
  Mic,
  PanelsTopLeft,
  Search,
  Settings,
  TrendingUp,
  Users
} from 'lucide-react';

/**
 * Sidebar Menu Configuration for ALICE Recruiting Platform
 * Organized in CRM-style sections
 */
export const MENU_SIDEBAR = [
  // Dashboard (Main)
  {
    title: 'Dashboard',
    icon: LayoutDashboard,
    path: '/dashboard',
  },

  // RECRUITMENT Section
  { heading: 'Recruitment' },
  {
    title: 'Candidates',
    icon: Users,
    children: [
      { title: 'All Candidates', path: '/all-candidates' },      // Updated: Internal Search
      { title: 'Candidate lists', path: '/candidate-lists' },
      { title: 'Search Candidates', path: '/people-search' },    // Updated: External Search Only
      { title: 'Contacts Database', path: '/contacts' },
    ],
  },
  {
    title: 'Communications',
    icon: MessageSquare,
    children: [
      { title: 'Conversations', path: '/conversation' },
      { title: 'Call History', path: '/calls' },
      { title: 'Email Campaigns', path: '/campaigns' },
    ],
  },

  // TOOLS Section
  { heading: 'Tools' },
  {
    title: 'ALICE AI',
    icon: Mic,
    path: '/conversation',
    badge: 'AI',
    badgeVariant: 'primary',
  },
  {
    title: 'Talent Insights',
    icon: TrendingUp,
    path: '/talent-insights',
  },
  {
    title: 'MIE v2 Studio',
    icon: TrendingUp,
    path: '/mie-intelligence',
    badge: 'NEW',
    badgeVariant: 'primary',
  },
  {
    title: 'Candidate Profile Builder',
    icon: PanelsTopLeft,
    path: '/candidate-profile-builder',
  },
  {
    title: 'Data Enrichment',
    icon: Database,
    path: '/data-enrichment',
  },

  // ACCOUNT Section
  { heading: 'Account' },
  {
    title: 'Settings',
    icon: Settings,
    path: '/settings',
  },
  {
    title: 'Billing',
    icon: CreditCard,
    path: '/billing',
  },
];

/**
 * Quick Actions - Can be shown in sidebar footer or separate section
 */
export const QUICK_ACTIONS = [
  {
    title: 'Launch ALICE',
    icon: Mic,
    path: '/conversation',
    variant: 'primary',
  },
  {
    title: 'Search People',
    icon: Search,
    path: '/people-search',
    variant: 'secondary',
  },
  {
    title: 'Market Intel',
    icon: TrendingUp,
    path: '/talent-insights',
    variant: 'outline',
  },
];

